export default __webpack_public_path__ + "static/media/Path 28.cbb4359e.svg";